import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formatRows, formatColumns } from './DataConfig'
import { AgGridReact } from 'ag-grid-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'

import { Card, Col, Container, Row } from 'reactstrap'
import { toast } from 'react-toastify'
import AxiosInstance from 'utils/AxiosInstance'

import * as checklistActions from 'store/Checklist/actions'
import {
  fetchGroupLocations,
  fetchCoreGroupCourses,
  fetchGroups,
  fetchRoles,
  fetchLocations,
} from 'store/Group/actions'
import {
  faChevronLeft,
  faChevronRight,
  faFileCsv,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

import {
  fetchCategories,
  getCourseManagerCoursesModule,
  addToBreadcrumb,
  onResetSearch,
  setManagerId,
  setCoursesUpdated,
  selectCourseManagerGroupsLocationGroupCourse,
  fetchRolesCounts,
  fetchUsersSavedFilters,
  setExternalReportsUpdated,
  setExternalReportsFocusedCell,
  setExternalReportsRows,
  setExternalReportsColumnDefs,
  setGroupsUpdated,
  setGroupsRows,
  setGroupsFocusedCell,
  setGroupsColumnDefs,
  setCoursesRows,
  setCoursesFocusedCell,
  setCoursesColumnDefs,
  setSelectedTab,
} from 'store/ManagerReport/actions'
import { fetchAllStores, fetchStores } from 'store/Stores/actions'

import Chart from '../Charts/index'
import Header from './Header'

import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import './styles/styles.css'
import { Route } from 'react-router-dom'
import Checklist from '../Checklist'
import { resetRefetchManagerReportsCourses } from 'store/ManagerReport/actions'
import { fetchGroup } from 'store/Group/actions'
import Submission from '../Submission'
import { setHideSubmissionData } from 'store/EmployeeReport/actions'
import { setLastPathname } from 'store/Course/actions'
import { useLocation, useHistory } from 'react-router'
import { getFontawesomeIconFromStatus } from './CellConfig'
import { getLabelForPublicCatalog } from 'utils/helpers'
import { getStatusColorReport } from 'utils/helpers'
import Search from '../Search'
import Loader from '../Loader'
import { fetchPublicCatalogForManagerReport } from 'store/ManagerReport/actions'
import { exportPublicCatalogToCsv } from 'store/ManagerReport/actions'
import { getPublicCatalogPercentages } from 'store/ManagerReport/actions'
import CustomReports from './CustomReport/CustomReports'
import { setCurrentSlide } from 'store/CustomReports/actions'
import { resetEverything } from 'store/CustomReports/actions'

const ManagerReport = (props) => {
  const dispatch = useDispatch()
  const location = useLocation()
  useEffect(() => {
    dispatch(setLastPathname(location.pathname))
  }, [])
  const user = useSelector((state) => state.auth.user)
  const managerReport = useSelector((state) => state.managerReport)
  const { currentSlide } = useSelector((state) => state.customReports)
  // const language = useSelector((state) => state.language?.language?.data)

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const [showingChart, setShowingChart] = useState(false)
  const [managerUsers, setManagerUsers] = useState([])
  const [feedAvailable, setFeedAvailable] = useState(false)
  const [feedRunning, setFeedRunning] = useState(false)

  useEffect(() => {
    const { managerId } = managerReport
    if (managerReport.selectedTab === 'groups') {
      selectCourseManagerGroupsLocationGroupCourse(
        props.history,
        managerReport.selectedCourseManagerGroupsLocationGroups,
      )
    } else {
      getCourseManagerCoursesModule(props.history, managerId)
    }
  }, [managerReport, props.history])
  const { exportButton, exportTrainingButton } = managerReport

  const activateCharts = exportButton || exportTrainingButton ? true : false

  const colStyle = user.access === 1 ? 'col2' : 'col4'

  useEffect(() => {
    if (user.access !== 1) {
      return
    }

    AxiosInstance.get('/manager-reports/feed')
      .then((data) => {
        setFeedAvailable(Boolean(data && data.available))
        setFeedRunning(Boolean(data && data.running))
      })
      .catch(() => {})
  }, [user.access])

  useEffect(() => {
    if (!feedRunning) {
      return
    }

    const timer = setInterval(() => {
      AxiosInstance.get('/manager-reports/feed')
        .then((data) => {
          const stillRunning = Boolean(data && data.running)
          setFeedRunning(stillRunning)
          if (!stillRunning) {
            toast.info('Feed finished.', {
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 4000,
            })
          }
        })
        .catch(() => {})
    }, 15000)

    return () => clearInterval(timer)
  }, [feedRunning])

  const runFeed = () => {
    if (
      !window.confirm(
        'Run the user feed now? This can take several minutes.'
      )
    ) {
      return
    }

    setFeedRunning(true)
    AxiosInstance.post('/manager-reports/feed/run', {})
      .then((data) => {
        if (data && data.started) {
          toast.info('Feed started. It keeps running in the background.', {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 4000,
          })
          return
        }

        setFeedRunning(Boolean(data && data.running))
        toast.info(data?.message || 'Could not start the feed.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 4000,
        })
      })
      .catch(() => {
        setFeedRunning(false)
        toast.info('Could not start the feed.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 4000,
        })
      })
  }

  return (
    <>
      <Container className='mt--6' fluid>
        <Card className='py-3 col' style={{ minHeight: '85vh' }}>
          <div
            id='manager-report-container'
            className={
              (showingChart &&
                managerReport.groupsRows.length &&
                managerReport.selectedTab === 'groups') ||
              (showingChart &&
                managerReport.coursesRows.length &&
                managerReport.selectedTab === 'courses')
                ? 'full-width-container-with-charts'
                : 'full-width-container'
            }
          >
            {(() => {
              // if (
              // 	courseConfig.enableCoursesManagerReport === 1 &&
              // 	courseConfig.enableGroupsManagerReport === 1
              // ) {
              return (
                <>
                  <Row
                    className='pt-3 pl-3 pr-3 pb-2 d-flex align-items-start row tabs-center flex-column'
                    style={{ gap: '10px' }}
                  >
                    <div
                      className='settings-tabs leon gap-10 mb-0 ml-lg-3 py-1 col-10'
                      style={{
                        gridTemplateColumns:
                          user.access === 1
                            ? 'repeat(8, 1fr)'
                            : 'repeat(12, 1fr)',
                      }}
                    >
                      <span
                        className={`${colStyle} lg-col12 itemsCenter textCenter tabs-center ${
                          managerReport.selectedTab === 'courses'
                            ? 'current'
                            : null
                        }`}
                        onClick={() => [
                          dispatch(setSelectedTab('courses')),
                          setShowingChart(false),
                        ]}
                      >
                        {language.settings
                          ? language.settings.courses
                          : 'Courses'}
                      </span>
                      {user.access === 1 && (
                        <span
                          className={`${colStyle} lg-col12 itemsCenter textCenter tabs-center ${
                            managerReport.selectedTab === 'catalog'
                              ? 'current'
                              : null
                          }`}
                          onClick={() => [
                            dispatch(setSelectedTab('catalog')),
                            setShowingChart(false),
                          ]}
                        >
                          Public Catalog
                        </span>
                      )}
                      <span
                        className={`${colStyle} lg-col12 itemsCenter textCenter tabs-center ${
                          managerReport.selectedTab === 'groups'
                            ? 'current'
                            : null
                        }`}
                        onClick={() => [
                          dispatch(setSelectedTab('groups')),
                          setShowingChart(false),
                        ]}
                      >
                        {language.settings
                          ? language.settings.group_management
                          : 'Course Groups'}
                      </span>
                      {/* {courseConfig.enableExternalReports === 1 ? ( */}
                      {/* <span
                        className={`${colStyle} lg-col12 itemsCenter textCenter tabs-center ${
                          managerReport.selectedTab === 'external-reports'
                            ? 'current'
                            : null
                        }`}
                        onClick={() => [
                          dispatch(setSelectedTab('external-reports')),
                          setShowingChart(false),
                        ]}
                      >
                        External Reports
                      </span> */}

                      <span
                        className={`${colStyle} lg-col12 itemsCenter textCenter tabs-center ${
                          managerReport.selectedTab === 'custom-reports'
                            ? 'current'
                            : null
                        }`}
                        onClick={() => [
                          dispatch(setSelectedTab('custom-reports')),
                          setShowingChart(false),
                        ]}
                      >
                        Custom Reports
                      </span>
                      {/* ) : null} */}
                    </div>
                    {managerReport.selectedTab !== 'custom-reports' ? (
                      <div className={'ps-2 view-charts ml-lg-3'}>
                        {showingChart === true &&
                        (managerReport.groupsRows.length ||
                          managerReport.coursesRows.length ||
                          managerReport.publicCatalogRowData.length) ? (
                          <button
                            id='chart-span-hide'
                            onClick={() => setShowingChart(false)}
                            className='btn show-table-icon font-weight-bold'
                          >
                            Hide Charts
                          </button>
                        ) : (
                          <button
                            id='chart-span-view'
                            className={`btn font-weight-bold show-table-icon${
                              !activateCharts ? ' disabled-charts' : ''
                            }`}
                            onClick={
                              (managerReport.groupsRows.length &&
                                managerReport.selectedTab === 'groups') ||
                              (managerReport.coursesRows.length &&
                                managerReport.selectedTab === 'courses') ||
                              (managerReport.publicCatalogRowData.length &&
                                managerReport.selectedTab === 'catalog') ||
                              (managerReport.externalReportsRows.length &&
                                managerReport.selectedTab ===
                                  'external-reports')
                                ? () => setShowingChart(true)
                                : null
                            }
                          >
                            View Charts
                          </button>
                        )}
                      </div>
                    ) : (
                      <>
                        {currentSlide ? (
                          <button
                            className='btn btn-danger ml-auto'
                            onClick={() => {
                              dispatch(setCurrentSlide(0))
                              dispatch(resetEverything())
                            }}
                          >
                            <FontAwesomeIcon icon={faXmark} className='mr-1' />{' '}
                            Exit
                          </button>
                        ) : null}
                      </>
                    )}
                    {feedAvailable ? (
                      <div className='ps-2 ml-lg-2'>
                        <button
                          type='button'
                          className='btn btn-primary font-weight-bold'
                          disabled={feedRunning}
                          onClick={runFeed}
                        >
                          {feedRunning ? 'Feed running…' : 'Run feed'}
                        </button>
                      </div>
                    ) : null}
                  </Row>

                  <div className='pt-2 '>
                    {managerReport.selectedTab === 'courses' ? (
                      <ManagerReportCourses
                        showingChart={showingChart}
                        managerUsers={managerUsers}
                        {...props}
                      />
                    ) : managerReport.selectedTab === 'catalog' ? (
                      <CourseProgressTable showingChart={showingChart} />
                    ) : managerReport.selectedTab === 'custom-reports' ? (
                      <CustomReports />
                    ) : managerReport.selectedTab === 'groups' ? (
                      <ManagerReportGroups
                        showingChart={showingChart}
                        managerUsers={managerUsers}
                        {...props}
                      />
                    ) : (
                      <ManagerReportExternalReports
                        showingChart={showingChart}
                        managerUsers={managerUsers}
                        {...props}
                      />
                    )}
                  </div>
                </>
              )
            })()}
          </div>
        </Card>
      </Container>

      <Route
        exact
        path={`/manager-report/:userId/checklist`}
        render={(routeProps) => (
          <Checklist
            {...props}
            {...routeProps}
            language={language}
            userId={user.id}
            {...checklistActions}
            dispatch={dispatch}
          />
        )}
      />
    </>
  )
  // }
}
export const ManagerReportCourses = (props) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth.user)
  const groups = useSelector((state) => state.groups)
  const stores = useSelector((state) => state.stores)
  const generalConfig = useSelector((state) => state.generalConfig)
  const managerReport = useSelector((state) => state.managerReport)
  const roles = useSelector((state) => state.roles)
  const [chartNumber, setChartNumber] = useState(1)
  const [gridApi, setGridApi] = useState({})
  const [params, setParams] = useState({})
  const [timer, setTimer] = useState(null)
  const [rowClassRules, setRowClassRules] = useState({
    'location-rule': (params) => params.data.module === 'location',
  })

  const [storesState, setStoresState] = useState([])

  const employeeReport = useSelector((store) => store.employeeReport)
  const languageRedux = useSelector((state) => state.language.language?.data)

  const areCoursesLoading =
    managerReport.requestsLoading?.getCourseManagerCoursesModule || false

  const isSelectingCoursesFilterLoading =
    managerReport.requestsLoading?.selectCoursesSavedFilter

  const defaultColDef = useMemo(
    () => ({
      rowHeight: 50,
      // flex: 1,
      resizable: true,
      headerComponentParams: {
        template:
          '<div class="ag-cell-label-container" role="presentation">' +
          '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
          '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
          '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
          '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
          '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
          '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
          '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
          '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
          '  </div>' +
          '</div>',
      },
    }),
    [],
  )

  useEffect(() => {
    if (
      managerReport.refetchCourses ||
      managerReport.selectedCoursesSavedFilter === null
    ) {
      dispatch(fetchUsersSavedFilters())
      dispatch(fetchGroups(undefined, false))
      dispatch(getCourseManagerCoursesModule())
      dispatch(fetchRolesCounts())
      dispatch(fetchRoles())
      dispatch(fetchLocations())
      dispatch(fetchGroupLocations())
      dispatch(fetchCategories())
      dispatch(fetchCoreGroupCourses())
      dispatch(fetchStores())
      dispatch(fetchAllStores())

      dispatch(resetRefetchManagerReportsCourses())
      dispatch({ type: 'SET_EXPORT_BUTTON', exportButton: true })
    }
  }, [
    dispatch,
    managerReport.refetchCourses,
    managerReport.selectedCoursesSavedFilter,
  ])

  useEffect(() => {
    if (!storesState.length) {
      if (stores.stores) {
        setStoresState(stores?.stores)
      }
    }
  }, [stores?.stores, storesState.length])

  const onGridReady = (params) => {
    setGridApi(params.api)
    setParams(params)
    setTimer(null)
    setRowClassRules({
      'location-rule': (params) => params.data.module === 'location',
    })
  }

  const handleLocationClick = (moduleParent) => {
    const currentLocation = managerReport.coursesRows.find(
      (item) => item.moduleName === moduleParent,
    )

    if (currentLocation) {
      if (currentLocation.isActive) {
        const customRows = managerReport.coursesRows

        customRows.map((item) => {
          item.moduleName === moduleParent ? (item.isActive = false) : null //eslint-disable-line
          item.moduleParent === moduleParent ? (item.isShowing = false) : null //eslint-disable-line
        })
        dispatch(setCoursesRows(customRows))
      } else {
        const customRows = managerReport.coursesRows

        customRows.map((item) => {
          item.moduleName === moduleParent ? (item.isActive = true) : null //eslint-disable-line
          item.moduleParent === moduleParent ? (item.isShowing = true) : null //eslint-disable-line
        })
        dispatch(setCoursesRows(customRows))
      }
    }
  }
  const setFormatedColumns = (columnData) => {
    dispatch(setCoursesColumnDefs(formatColumns(columnData)))
  }

  const setFormatedRows = (data, header, prevRows) => {
    if (data && data.length) {
      dispatch(
        setCoursesRows(
          formatRows(
            data,
            header,
            user.access,
            prevRows,
            groups.locationGroups.length,
            generalConfig.corporateHierarchy,
          ),
        ),
      )
    }
  }

  const onCellClicked = () => {
    dispatch(setCoursesFocusedCell(gridApi.getFocusedCell()))
  }

  useEffect(() => {
    if (
      managerReport.courseModule !== undefined &&
      managerReport.courseModule !== null &&
      managerReport.courseModule.data &&
      managerReport.courseModule.data.length &&
      managerReport.courseModule.header &&
      managerReport.courseModule.header.length
    ) {
      setFormatedColumns(managerReport.courseModule?.header)

      setFormatedRows(
        managerReport.courseModule?.data,
        formatColumns(managerReport.courseModule?.header),
        managerReport?.coursesRows,
      )
    }
    if (managerReport.coursesUpdated) {
      setFormatedColumns(managerReport.courseModule.header)
      setFormatedRows(
        managerReport.courseModule.data,
        formatColumns(managerReport.courseModule.header),
        managerReport.coursesRows,
      )
      setCoursesUpdated(false)
    }
  }, [managerReport.courseModule])

  useEffect(() => {
    // This useEffect runs whenever coursesRows changes
    // You can leave the body of the useEffect empty
  }, [managerReport.coursesRows])

  let overAllPercentage = []

  let locationNames = []

  let locationsOnFilter = 0
  let overAll = 0
  let notStarted = 0
  let notActive = 0
  let inProgress = 0
  let needsManagerApproval = 0
  let checkList = 0
  let certifiedUsers = 0

  managerReport.courseModule &&
    managerReport.courseModule.data &&
    managerReport.courseModule.data.map((row) => {
      switch (row.module) {
        case 'employee':
          row.module_data.map((course) => {
            switch (course.status) {
              case 0:
                notStarted = notStarted + 1
                break
              case null:
                notActive = notActive + 1
                break
              case 1:
                inProgress = inProgress + 1
                break
              case 3:
                needsManagerApproval = needsManagerApproval + 1
                break
              case 2:
                checkList = checkList + 1
                break
              case 4:
                certifiedUsers = certifiedUsers + 1
                break
              default:
                break
            }
          })
          break
        case 'location':
          locationsOnFilter = locationsOnFilter + 1
          overAllPercentage.push(Number(row.module_data[0].name.split(' ')[0]))
          locationNames.push(row.name)
          break
        default:
          break
      }
    })

  const arrayOfUsers = managerReport.coursesRows.length - locationsOnFilter

  const overAllAverage = Math.round(overAll / locationsOnFilter)

  const locationPercentages = {
    locationNames,
    overAllPercentage,
  }

  const allCourses =
    notStarted +
    notActive +
    inProgress +
    needsManagerApproval +
    checkList +
    certifiedUsers

  const allAsignedCourses = allCourses - notActive

  let certifiedPercentage = Math.round(
    (certifiedUsers / allAsignedCourses) * 100,
  )

  let notStartedPercentage = Math.round((notStarted / allAsignedCourses) * 100)
  let notActivePercentage = Math.round((notActive / allCourses) * 100)
  let inProgressPercentage = Math.round((inProgress / allAsignedCourses) * 100)
  let needsManagerApprovalPercentage = Math.round(
    (needsManagerApproval / allAsignedCourses) * 100,
  )

  let percentage = {
    certifiedPercentage: certifiedPercentage,
    inProgressPercentage: inProgressPercentage,
    notStartedPercentage: notStartedPercentage,
    needsManagerApproval: needsManagerApprovalPercentage,
    notActivePercentage: notActivePercentage,
  }

  const coursesRows = managerReport.coursesRows
  const coursesColumnDefs = managerReport.searchByCore
    ? managerReport.coursesColumnDefs
    : managerReport.coursesColumnDefs.filter(
        (item) => !item.headerName.includes('Core'),
      )

  return (
    <div>
      <Header
        {...props}
        type={'courses'}
        roles={roles.roles}
        stores={stores.stores}
        storesState={storesState}
      />

      {/* Filter is being applied/loading */}
      {isSelectingCoursesFilterLoading ? (
        <div
          className='d-flex flex-column justify-content-center align-items-center'
          style={{ gap: '20px', height: '50vh' }}
        >
          <div className='spinner-border text-primary' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
          <span className='ml-2 text-muted'>Loading courses report...</span>
        </div>
      ) : managerReport.coursesRows.length ||
        ((user.access === 2 || user.second_access === 2) &&
          managerReport.coursesRows.length) ? (
        <div className='ag-theme-alpine manager-report-grid'>
          {props.showingChart === true ? (
            <Col className='charts-container'>
              {chartNumber === 1 ? (
                <React.Fragment>
                  <Chart
                    {...props}
                    chart={'AllUsersChart'}
                    chartNumber={chartNumber}
                    numberOfAllUsers={arrayOfUsers}
                    locationPercentages={locationPercentages}
                    overAllAverage={overAllAverage}
                  />
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    key={1}
                    className='chevron-right'
                    onClick={() => setChartNumber(2)}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    key={2}
                    className='chevron-left'
                    onClick={() => setChartNumber(1)}
                  />
                  <Chart
                    {...props}
                    chart={'N/A'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                  <Chart
                    {...props}
                    chart={'In Progress'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                  <Chart
                    {...props}
                    chart={'Not Started'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                  <Chart
                    {...props}
                    chart={'Need Manager Approval'}
                    fourth={4}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                </React.Fragment>
              )}
            </Col>
          ) : (
            ''
          )}

          {employeeReport.isShowingSubmission &&
          employeeReport.currentSubmission ? (
            <Submission
              submission={employeeReport.currentSubmission}
              language={languageRedux}
              isShowing={employeeReport.isShowingSubmission}
              setHideSubmissionData={setHideSubmissionData}
              {...employeeReport}
            />
          ) : null}

          {managerReport.courseModule.data &&
            managerReport.courseModule.data.length && (
              <>
                <BreadCrumb {...props} managerReport={managerReport} />
                <AgGridReact
                  onGridReady={onGridReady}
                  mainProps={props}
                  columnDefs={
                    managerReport.searchValueOnClick &&
                    managerReport.searchByHeader
                      ? coursesColumnDefs.filter(
                          (item) =>
                            item.headerName === '' ||
                            item.headerName === 'Overall' ||
                            item.headerName
                              .trim()
                              .toLowerCase()
                              .indexOf(
                                managerReport.searchValueOnClick
                                  .trim()
                                  .toLowerCase(),
                              ) !== -1,
                        )
                      : managerReport.searchByCore
                        ? coursesColumnDefs.filter(
                            (item) =>
                              item.headerName.includes('Core') ||
                              item.headerName === '' ||
                              groups?.coreGroupsCourses?.findIndex((course) =>
                                item.headerName.includes(course.name),
                              ) !== -1,
                          )
                        : coursesColumnDefs.filter(
                            (item) => item.headerName !== 'Core',
                          )
                  }
                  rowData={
                    managerReport.searchValueOnClick &&
                    managerReport.searchByData
                      ? coursesRows
                          .filter(
                            (item) =>
                              item.moduleName
                                .trim()
                                .toLowerCase()
                                .indexOf(
                                  managerReport.searchValueOnClick
                                    .trim()
                                    .toLowerCase(),
                                ) !== -1,
                          )
                          .filter(
                            (item, index, self) =>
                              self.findIndex(
                                (obj) => obj.moduleId === item.moduleId,
                              ) === index,
                          )
                      : coursesRows.filter((item) => item.isShowing)
                  }
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                  suppressCellSelection={true}
                  addToBreadcrumb={addToBreadcrumb}
                  setManagerId={setManagerId}
                  rowBuffer={10}
                  animateRows={true}
                  context={{ handleLocationClick: handleLocationClick }}
                  alwaysShowVerticalScroll={true}
                  autoSizeColumns={true}
                  handleLocationClick={handleLocationClick}
                  rowClassRules={rowClassRules}
                  suppressScrollOnNewData={true}
                  suppressCellFocus={true}
                  onCellClicked={onCellClicked}
                ></AgGridReact>
              </>
            )}
        </div>
      ) : managerReport.coursesInfoReport ? (
        <div className='no-data-report'>
          <p className='no-data-text'>{managerReport.coursesInfoReport}</p>
        </div>
      ) : areCoursesLoading ? (
        <div
          className='d-flex flex-column justify-content-center align-items-center'
          style={{ gap: '20px', height: '50vh' }}
        >
          <div className='spinner-border text-primary' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
          <span className='ml-2 text-muted'>Loading courses report...</span>
        </div>
      ) : null}
    </div>
  )
}

const findCourseName = (courseId, array) => {
  if (array && array.length) {
    return array.find((el) => el?.field?.split('_')?.at(1) == courseId)
      ?.headerName
  } else {
    return ''
  }
}

const CourseProgressTable = ({ showingChart }) => {
  const dispatch = useDispatch()
  const { publicCatalogDataFetched } = useSelector(
    (store) => store.managerReport,
  )

  const [chartNumber, setChartNumber] = useState(2)

  const {
    publicCatalogLoading: isLoading,
    publicCatalogRowData: rowData,
    publicCatalogColumnDefs: columnDefs,
    publicCatalogCharts,
    publicCatalogChartsLoading,
  } = useSelector((state) => state.managerReport)

  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    if (publicCatalogDataFetched) return
    dispatch(fetchPublicCatalogForManagerReport())
  }, [dispatch, publicCatalogDataFetched])

  const props = {
    chart: 'N/A',
    percentage: {
      certifiedPercentage: 69,
      inProgressPercentage: 69,
      notStartedPercentage: 69,
      needsManagerApproval: 69,
      notActivePercentage: 69,
    },
  }

  useEffect(() => {
    if (showingChart) dispatch(getPublicCatalogPercentages())
  }, [dispatch, showingChart])

  const courses =
    publicCatalogCharts &&
    publicCatalogCharts.length &&
    Object?.keys(publicCatalogCharts?.at(0))

  return (
    <>
      <div className=' col-3 mb-3 d-flex'>
        <button
          title={`"Export to " .csv`}
          className={`mr-3 btn btn-download btn-transparent p-1`}
          onClick={() => dispatch(exportPublicCatalogToCsv())}
        >
          <FontAwesomeIcon icon={faFileCsv} size={'2x'} />
        </button>
        <div className='w-100'>
          <Search
            placeholder={'Search'}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      </div>

      {isLoading ? (
        <div style={{ textAlign: 'center', fontSize: '20px', padding: '20px' }}>
          <Loader />
        </div>
      ) : (
        <div
          className='ag-theme-alpine scrollbar'
          style={{ height: 550, width: '100%', overflowY: 'auto' }}
        >
          {showingChart === true ? (
            publicCatalogChartsLoading ? (
              <Loader />
            ) : (
              <Col className='d-flex flex-column'>
                {chartNumber === 1 ? (
                  <React.Fragment>
                    {/* <Chart
                    {...props}
                    chart={'AllUsersChart'}
                    percentage={69}
                    chartNumber={chartNumber}
                    numberOfAllUsers={arrayOfUsers}
                    locationPercentages={locationPercentages}
                  />
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className='chevron-right'
                    onClick={() => setChartNumber(2)}
                  /> */}
                  </React.Fragment>
                ) : (
                  <>
                    {courses && courses.length
                      ? courses.map((course) => (
                          <PublicCatalogDoughnot
                            key={course}
                            chartNumber={chartNumber}
                            data={publicCatalogCharts?.at(0)?.[course]}
                            courseName={findCourseName(course, columnDefs)}
                          />
                        ))
                      : null}
                  </>
                )}
              </Col>
            )
          ) : (
            ''
          )}
          <AgGridReact
            rowData={rowData?.filter((data) =>
              data?.userName
                ?.toLowerCase()
                ?.includes(searchValue?.toLowerCase()),
            )}
            columnDefs={columnDefs}
            defaultColDef={{ resizable: true }}
          />
        </div>
      )}
    </>
  )
}

const PublicCatalogDoughnot = ({ data, chartNumber, courseName }) => {
  const props = {
    chart: 'N/A',
    percentage: {
      certifiedPercentage: data.percentages.certifiedPercentage,
      inProgressPercentage: data.percentages.inProgressPercentage,
      notStartedPercentage: data.percentages.notStartedPercentage,
      needsManagerApproval: data.percentages.needsManagerApproval,
      notActivePercentage: data.percentages.notActivePercentage,
    },
    numberofUsers: {
      certified: data.numberOfUsers.certified,
      inProgress: data.numberOfUsers.inProgress,
      needsManagerApproval: data.numberOfUsers.needsManagerApproval,
      notAssigned: data.numberOfUsers.notAssigned,
      notStarted: data.numberOfUsers.notStarted,
    },
  }

  return (
    <div className='d-flex my-5 align-items-center position-relative'>
      <h3 className='position-absolute' style={{ top: '-35px' }}>
        {courseName}
      </h3>
      <Chart
        {...props}
        chart={'N/A'}
        chartNumber={chartNumber}
        showCertificatePercentage={true}
      />
      <Chart
        {...props}
        chart={'In Progress'}
        chartNumber={chartNumber}
        showCertificatePercentage={true}
      />
      <Chart
        {...props}
        chart={'Certified'}
        chartNumber={chartNumber}
        showCertificatePercentage={true}
      />
      <Chart
        {...props}
        chart={'Not Started'}
        chartNumber={chartNumber}
        showCertificatePercentage={true}
      />
      <Chart
        {...props}
        chart={'Need Manager Approval'}
        fourth={4}
        chartNumber={chartNumber}
        showCertificatePercentage={true}
      />
    </div>
  )
}

export const ManagerReportGroups = (props) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth.user)
  const groups = useSelector((state) => state.groups)
  const roles = useSelector((state) => state.roles)
  const stores = useSelector((state) => state.stores)
  const managerReport = useSelector((state) => state.managerReport)
  const [gridApi, setGridApi] = useState({})
  const [params, setParams] = useState({})
  const [chartNumber, setChartNumber] = useState(1)
  const [showing, setShowing] = useState('hideCharts')
  const [timer, setTimer] = useState(null)
  const [rowClassRules, setRowClassRules] = useState({
    'location-rule': (params) => params.data.module === 'location',
  })

  const prevGroupsModule = useRef(managerReport.groupsModule)
  const prevGroupsRows = useRef(managerReport.groupsRows)

  const isSelectingGroupsFilterLoading =
    managerReport.requestsLoading?.selectGroupsSavedFilter || false

  useEffect(() => {
    dispatch(fetchUsersSavedFilters())
    dispatch(fetchGroups())
    dispatch(getCourseManagerCoursesModule())
    dispatch(fetchRolesCounts())
    dispatch(fetchLocations())
    dispatch(fetchGroupLocations())
    dispatch(fetchCategories())
    dispatch(fetchStores())
    dispatch(fetchCoreGroupCourses())
  }, [dispatch])

  useEffect(() => {
    if (managerReport.selectedGroupGroupsLocations) {
      dispatch(fetchGroup(managerReport.selectedGroupGroupsLocations.id))
    }
  }, [managerReport.selectedGroupGroupsLocations, dispatch])

  const onGridReady = (params) => {
    setGridApi(params.api)
    setParams(params)
    setTimer(null)
    setRowClassRules({
      'location-rule': (params) => params.data.module === 'location',
    })
  }

  const handleLocationClick = (moduleParent) => {
    const currentLocation = managerReport.groupsRows.find(
      (item) => item.moduleName === moduleParent,
    )

    if (currentLocation) {
      if (currentLocation.isActive) {
        const customRows = managerReport.groupsRows

        customRows.map((item) => {
          item.moduleName === moduleParent ? (item.isActive = false) : null //eslint-disable-line
          item.moduleParent === moduleParent ? (item.isShowing = false) : null //eslint-disable-line
        })
        dispatch(setGroupsRows(customRows))
      } else {
        const customRows = managerReport.groupsRows

        customRows.map((item) => {
          item.moduleName === moduleParent ? (item.isActive = true) : null //eslint-disable-line
          item.moduleParent === moduleParent ? (item.isShowing = true) : null //eslint-disable-line
        })
        dispatch(setGroupsRows(customRows))
      }
    }
  }

  const onCellClicked = (params) => {
    dispatch(setGroupsFocusedCell(gridApi.getFocusedCell()))
  }

  useEffect(() => {
    const { groupsModule } = managerReport
    const { groupsRows } = managerReport
    let isCompleted = false

    const setFormatedColumns = () => {
      // if (!isCompleted && groupsModule?.header.length) {
      if (!isCompleted) {
        dispatch(
          setGroupsColumnDefs(
            formatColumns(groupsModule?.header, handleLocationClick),
          ),
        )
      }
    }

    const setFormatedRows = () => {
      if (!isCompleted) {
        // if (groupsModule?.data.length && !isCompleted) {
        dispatch(
          setGroupsRows(
            formatRows(
              groupsModule?.data,
              formatColumns(groupsModule?.header),
              user.access,
              groupsRows,
              groups.locationGroups.length,
            ),
          ),
        )
      }
    }
    if (
      JSON.stringify(prevGroupsModule.current) !==
        JSON.stringify(groupsModule) ||
      JSON.stringify(prevGroupsRows.current) !== JSON.stringify(groupsRows)
    ) {
      setFormatedColumns()
      setFormatedRows()
      if (managerReport.groupsUpdated) {
        dispatch(setGroupsUpdated(false))
      }
    }
    prevGroupsModule.current = groupsModule
    prevGroupsRows.current = groupsRows

    return () => (isCompleted = true)
  }, [managerReport, user, dispatch, groups.locationGroups.length])

  let certifiedUsers = 0
  let notStartedUsers = 0
  let inProgressUsers = 0
  let notActiveUsers = 0
  let needsManagerApproval = 0
  let locationsOnFilter = 0
  let locationNames = []
  let overAllPercentage = []

  managerReport.groupsRows.map((row) => {
    if (row.Status) {
      switch (row.Status.status) {
        case 0:
          notStartedUsers = notStartedUsers + 1

          break
        case 1:
          inProgressUsers = inProgressUsers + 1

          break
        case 3:
          needsManagerApproval = needsManagerApproval + 1

          break
        case 4:
          certifiedUsers = certifiedUsers + 1

          break
        case null:
          notActiveUsers = notActiveUsers + 1
          break

        default:
          break
      }

      switch (row.module) {
        case 'location':
          locationNames.push(row.moduleName)
          locationsOnFilter = locationsOnFilter + 1
          overAllPercentage.push(Number(row.Status.name.split(' ')[0]))

          break
        default:
          break
      }
    }
  })

  const arrayOfUsers = managerReport.groupsRows.length - locationsOnFilter

  let notActivePercentage = Math.round((notActiveUsers / arrayOfUsers) * 100)

  let certifiedPercentage = Math.round((certifiedUsers / arrayOfUsers) * 100)
  let inProgressPercentage = Math.round((inProgressUsers / arrayOfUsers) * 100)

  let needsManagerApprovalPercentage = Math.round(
    (needsManagerApproval / arrayOfUsers) * 100,
  )
  let notStartedPercentage = Math.round((notStartedUsers / arrayOfUsers) * 100)

  let percentage = {
    certifiedPercentage: certifiedPercentage,
    inProgressPercentage: inProgressPercentage,
    notStartedPercentage: notStartedPercentage,
    needsManagerApproval: needsManagerApprovalPercentage,
    notActivePercentage: notActivePercentage,
  }

  const locationPercentages = {
    locationNames,
    overAllPercentage,
  }

  return (
    <div>
      <Header
        {...props}
        type={'groups'}
        roles={roles.roles}
        stores={stores.stores}
      />

      {isSelectingGroupsFilterLoading ? (
        // Loading spinner overlay
        <div
          className='d-flex flex-column justify-content-center align-items-center'
          style={{ gap: '20px', height: '50vh' }}
        >
          <div className='spinner-border text-primary' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
          <span className='ml-2 text-muted'>
            Loading course group report...
          </span>
        </div>
      ) : managerReport.groupsRows.length > 0 ? (
        // Main table and charts
        <div className='ag-theme-alpine manager-report-grid'>
          {props.showingChart && (
            <Col className='charts-container'>
              {chartNumber === 1 ? (
                <>
                  <Chart
                    {...props}
                    chart={'AllUsersChart'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                    numberOfAllUsers={arrayOfUsers}
                    locationPercentages={locationPercentages}
                  />
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className='chevron-right'
                    onClick={() => setChartNumber(2)}
                  />
                </>
              ) : (
                <>
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className='chevron-left'
                    onClick={() => setChartNumber(1)}
                  />
                  <Chart
                    {...props}
                    chart={'N/A'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                  <Chart
                    {...props}
                    chart={'In Progress'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                  <Chart
                    {...props}
                    chart={'Not Started'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                  <Chart
                    {...props}
                    chart={'Need Manager Approval'}
                    fourth={4}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                </>
              )}
            </Col>
          )}

          <AgGridReact
            mainProps={props}
            onGridReady={onGridReady}
            columnDefs={
              managerReport.searchValueOnClick && managerReport.searchByHeader
                ? managerReport.groupsColumnDefs.filter(
                    (item) =>
                      item.headerName === '' ||
                      item.headerName === 'Overall' ||
                      item.headerName === 'Username' ||
                      item.headerName
                        .trim()
                        .toLowerCase()
                        .includes(
                          managerReport.searchValueOnClick.trim().toLowerCase(),
                        ),
                  )
                : managerReport.groupsColumnDefs
            }
            rowData={
              managerReport.searchValueOnClick && managerReport.searchByData
                ? managerReport.groupsRows.filter((item) =>
                    item.moduleName
                      .trim()
                      .toLowerCase()
                      .includes(
                        managerReport.searchValueOnClick.trim().toLowerCase(),
                      ),
                  )
                : managerReport.groupsRows.filter((item) => item.isShowing)
            }
            enableBrowserTooltips={true}
            animateRows={true}
            alwaysShowVerticalScroll={true}
            autoSizeColumns={true}
            suppressCellFocus={true}
            context={{ handleLocationClick }}
            handleLocationClick={handleLocationClick}
            rowClassRules={rowClassRules}
            suppressScrollOnNewData={true}
            onCellClicked={onCellClicked}
          />
        </div>
      ) : managerReport.groupsInfoReport ? (
        // No data message from API
        <div className='no-data-report'>
          <p className='no-data-text'>{managerReport.groupsInfoReport}</p>
        </div>
      ) : (
        // No rows and no report
        <div
          className='d-flex flex-column justify-content-center align-items-center text-center'
          style={{ height: '50vh' }}
        >
          <h3>No course group reports detected.</h3>
          <p>
            Try selecting a filter or create a new one to view course group
            reports.
          </p>
        </div>
      )}
    </div>
  )
}

export const ManagerReportExternalReports = (props) => {
  const dispatch = useDispatch()
  const { user, managerReport, groups, roles, stores } = useSelector(
    (state) => ({
      user: state.auth.user,
      managerReport: state.managerReport,
      groups: state.groups,
      roles: state.roles,
      stores: state.stores,
    }),
  )
  const [chartNumber, setChartNumber] = useState(1)
  const [gridApi, setGridApi] = useState({})
  const [params, setParams] = useState({})
  const [timer, setTimer] = useState(null)
  const [rowClassRules, setRowClassRules] = useState({
    'location-rule': (params) => params.data.module === 'location',
  })

  const isSelectingExternalReportsFilterLoading =
    managerReport.requestsLoading?.selectExternalReportsSavedFilter || false

  const prevExternalReportsModule = useRef(managerReport.externalReportsModule)
  const prevExternalReportsRows = useRef(managerReport.externalReportsRows)

  useEffect(() => {
    dispatch(fetchUsersSavedFilters())
    dispatch(fetchGroups())
    dispatch(getCourseManagerCoursesModule())
    dispatch(fetchRolesCounts())
    dispatch(fetchLocations())
    dispatch(fetchGroupLocations())
    dispatch(fetchCategories())
    dispatch(fetchCoreGroupCourses())
    dispatch(fetchStores())
  }, [dispatch])

  const onGridReady = (params) => {
    setGridApi(params.api)
    setParams(params)
  }
  const handleLocationClick = (moduleParent) => {
    const currentLocation = managerReport.externalReportsRows.find(
      (item) => item.moduleName === moduleParent,
    )

    if (currentLocation) {
      if (currentLocation.isActive) {
        const customRows = managerReport.externalReportsRows

        customRows.map((item) => {
          item.moduleName === moduleParent ? (item.isActive = false) : null //eslint-disable-line
          item.moduleParent === moduleParent ? (item.isShowing = false) : null //eslint-disable-line
        })
        dispatch(setExternalReportsRows(customRows))
      } else {
        const customRows = managerReport.externalReportsRows

        customRows.map((item) => {
          item.moduleName === moduleParent ? (item.isActive = true) : null //eslint-disable-line
          item.moduleParent === moduleParent ? (item.isShowing = true) : null //eslint-disable-line
        })
        dispatch(setExternalReportsRows(customRows))
      }
    }
  }

  const onCellClicked = (params) => {
    dispatch(setExternalReportsFocusedCell(gridApi.getFocusedCell()))
  }
  useEffect(() => {
    const { externalReportsModule, externalReportsRows } = managerReport
    let isCompleted = false

    const setFormatedColumns = () => {
      if (!isCompleted && externalReportsModule?.header?.length) {
        dispatch(
          setExternalReportsColumnDefs(
            formatColumns(externalReportsModule?.header),
          ),
        )
        prevExternalReportsModule.current = externalReportsModule
      }
    }

    const setFormatedRows = () => {
      if (!isCompleted && externalReportsModule?.data?.length) {
        dispatch(
          setExternalReportsRows(
            formatRows(
              externalReportsModule?.data,
              formatColumns(externalReportsModule?.header),
              user.access,
              externalReportsRows,
              groups.locationGroups.length,
            ),
          ),
        )
        prevExternalReportsRows.current = externalReportsRows
      }
    }

    if (
      JSON.stringify(prevExternalReportsModule.current) !==
        JSON.stringify(externalReportsModule) ||
      JSON.stringify(prevExternalReportsRows.current) !==
        JSON.stringify(externalReportsRows)
    ) {
      setFormatedColumns()
      setFormatedRows()

      if (managerReport.externalReportsUpdated) {
        dispatch(setExternalReportsUpdated(false))
      }
    }

    return () => (isCompleted = true)
  }, [managerReport, user, dispatch, groups.locationGroups.length])

  let overAllPercentage = []
  let locationNames = []
  let locationsOnFilter = 0
  let overAll = 0
  let notStarted = 0
  let notActive = 0
  let inProgress = 0
  let needsManagerApproval = 0
  let checkList = 0
  let certifiedUsers = 0

  managerReport.externalReportsModule &&
    managerReport.externalReportsModule.data &&
    managerReport.externalReportsModule.data.map((row) => {
      let module
      switch (row.module) {
        case 'employee':
          row.module_data.map((course) => {
            let courseStatus
            switch (course.status) {
              case 0:
                notStarted = notStarted + 1
                break
              case null:
                notActive = notActive + 1
                break
              case 1:
                inProgress = inProgress + 1
                break
              case 3:
                needsManagerApproval = needsManagerApproval + 1
                break
              case 2:
                checkList = checkList + 1
                break
              case 4:
                certifiedUsers = certifiedUsers + 1
                break
            }
            return courseStatus
          })
          break
        case 'location':
          locationsOnFilter = locationsOnFilter + 1
          overAllPercentage.push(Number(row.module_data[0].name.split(' ')[0]))
          locationNames.push(row.name)

          break
      }
      return module
    })

  const arrayOfUsers =
    managerReport.externalReportsRows.length - locationsOnFilter

  const overAllAverage = Math.round(overAll / locationsOnFilter)

  const locationPercentages = {
    locationNames,
    overAllPercentage,
  }

  const allCourses =
    notStarted +
    notActive +
    inProgress +
    needsManagerApproval +
    checkList +
    certifiedUsers

  const allAsignedCourses = allCourses - notActive

  let certifiedPercentage = Math.round(
    (certifiedUsers / allAsignedCourses) * 100,
  )

  let notStartedPercentage = Math.round((notStarted / allAsignedCourses) * 100)
  let notActivePercentage = Math.round((notActive / allCourses) * 100)
  let inProgressPercentage = Math.round((inProgress / allAsignedCourses) * 100)
  let needsManagerApprovalPercentage = Math.round(
    (needsManagerApproval / allAsignedCourses) * 100,
  )

  let percentage = {
    certifiedPercentage: certifiedPercentage,
    inProgressPercentage: inProgressPercentage,
    notStartedPercentage: notStartedPercentage,
    needsManagerApproval: needsManagerApprovalPercentage,
    notActivePercentage: notActivePercentage,
  }

  const externalReportsRows =
    user.location === 'Corporate'
      ? managerReport.externalReportsRows.filter(
          (item) =>
            item.module === 'location' ||
            props.managerUsers.includes(item.moduleId),
        )
      : managerReport.externalReportsRows

  return (
    <div>
      <Header
        {...props}
        managerReport={managerReport}
        type={'external-reports'}
        roles={roles.roles}
        stores={stores.stores}
      />

      {isSelectingExternalReportsFilterLoading ? (
        <div
          className='d-flex flex-column justify-content-center align-items-center'
          style={{ gap: '20px', height: '50vh' }}
        >
          <div className='spinner-border text-primary' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
          <span className='ml-2 text-muted'>Loading external report...</span>
        </div>
      ) : managerReport.externalReportsRows?.length ||
        ((user.access === 2 || user.second_access === 2) &&
          managerReport.externalReportsRows?.length) ? (
        <div className='ag-theme-alpine manager-report-grid'>
          {props.showingChart === true && (
            <Col className='charts-container'>
              {chartNumber === 1 ? (
                <React.Fragment>
                  <Chart
                    {...props}
                    chart={'AllUsersChart'}
                    chartNumber={chartNumber}
                    numberOfAllUsers={arrayOfUsers}
                    locationPercentages={locationPercentages}
                    overAllAverage={overAllAverage}
                  />
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    key={1}
                    className='chevron-right'
                    onClick={() => setChartNumber(2)}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    key={2}
                    className='chevron-left'
                    style={{ cursor: 'pointer' }}
                    onClick={() => setChartNumber(1)}
                  />
                  <Chart
                    {...props}
                    chart={'N/A'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                  <Chart
                    {...props}
                    chart={'In Progress'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                  <Chart
                    {...props}
                    chart={'Not Started'}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                  <Chart
                    {...props}
                    chart={'Need Manager Approval'}
                    fourth={4}
                    percentage={percentage}
                    chartNumber={chartNumber}
                  />
                </React.Fragment>
              )}
            </Col>
          )}

          <AgGridReact
            mainProps={props}
            onGridReady={onGridReady}
            className={'manager-report-grid'}
            columnDefs={
              managerReport.searchValueOnClick && managerReport.searchByHeader
                ? managerReport.externalReportsColumnDefs.filter(
                    (item) =>
                      item.headerName === '' ||
                      item.headerName === 'Overall' ||
                      item.headerName
                        .trim()
                        .toLowerCase()
                        .indexOf(
                          managerReport.searchValueOnClick.trim().toLowerCase(),
                        ) !== -1,
                  )
                : managerReport.searchByCore
                  ? managerReport.externalReportsColumnDefs.filter(
                      (item) =>
                        item.headerName === '' ||
                        item.headerName === 'Overall' ||
                        props.groups.coreGroupsCourses.findIndex(
                          (course) => course.name === item.headerName,
                        ) !== -1,
                    )
                  : managerReport.externalReportsColumnDefs
            }
            rowData={
              managerReport.searchValueOnClick && managerReport.searchByData
                ? externalReportsRows.filter(
                    (item) =>
                      item.moduleName
                        .trim()
                        .toLowerCase()
                        .indexOf(
                          managerReport.searchValueOnClick.trim().toLowerCase(),
                        ) !== -1,
                  )
                : externalReportsRows.filter((item) => item.isShowing)
            }
            enableBrowserTooltips={true}
            animateRows={true}
            alwaysShowVerticalScroll={true}
            autoSizeColumns={true}
            suppressCellFocus={true}
            context={{ handleLocationClick: handleLocationClick }}
            handleLocationClick={handleLocationClick}
            rowClassRules={rowClassRules}
            suppressScrollOnNewData={true}
            onCellClicked={onCellClicked}
            addToBreadcrumb={addToBreadcrumb}
            setManagerId={setManagerId}
          ></AgGridReact>
        </div>
      ) : managerReport.externalReportsInfoReport ? (
        <div className='no-data-report'>
          <p className='no-data-text'>
            {managerReport.externalReportsInfoReport}
          </p>
        </div>
      ) : (
        <div
          className='d-flex flex-column justify-content-center align-items-center text-center'
          style={{ height: '50vh' }}
        >
          <h3>No external reports detected.</h3>
          <p>
            Try selecting a filter or create a new one to view external reports.
          </p>
        </div>
      )}
    </div>
  )
}

const BreadCrumb = (props) => {
  const dispatch = useDispatch()
  const { managerReport } = props
  return (
    <div className='breadcrumb-wrapper-manager-report'>
      {managerReport.breadcrumb && managerReport.breadcrumb.length > 0 ? (
        <span
          style={{
            marginRight: '5px',
            display: 'inline-block',
            verticalAlign: 'middle',
            color: 'black',
          }}
        >
          <a
            href='#'
            onClick={(e) => {
              e.preventDefault()
              dispatch(setManagerId(null))
            }}
            className='back-library-label'
          >
            Manager Report
          </a>
        </span>
      ) : null}
      {props.managerReport.breadcrumb && props.managerReport.breadcrumb.length
        ? props.managerReport.breadcrumb.map((item) => (
            <a
              href='#'
              key={item.id}
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
              onClick={(e) => {
                e.preventDefault()
                dispatch(setManagerId(item.id))
              }}
            >
              <span className='divider'> / </span>
              {item.name}
            </a>
          ))
        : null}
    </div>
  )
}

export default ManagerReport
